var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "table",
      staticClass: "c-table",
      class: {
        "c-table_scrolled": _vm.isScrolled,
        "c-table_scroll_end": _vm.isScrollEnd,
        "c-table_scroll": _vm.isScroll,
      },
    },
    [
      _c("m-column-filters", {
        ref: "columnFilters",
        attrs: {
          column: _vm.filteredColumn,
          "reference-list": _vm.referenceList,
          "active-filters": _vm.activeFilteredColumns,
        },
        on: {
          getReferenceValues: _vm.getReferenceValues,
          close: function ($event) {
            _vm.filteredColumn = null
          },
          setFilter: _vm.setColumnFilter,
          removeFilter: _vm.removeColumnFilter,
        },
      }),
      _vm.data.records.length !== 0
        ? _c("div", {
            class: {
              "c-table__shadow": _vm.data.actions,
              "c-table__shadow_active": _vm.data.actions,
              // 'c-table__empty__shadow': data.records.length === 0
            },
          })
        : _vm._e(),
      _vm.isScroll
        ? _c("div", { staticClass: "c-table__scrollbar-wrapper" })
        : _vm._e(),
      _c(
        "perfect-scrollbar",
        {
          ref: "wrapper",
          staticClass: "c-table__wrapper",
          on: { scroll: _vm.scroll },
        },
        [
          _c("table", { ref: "container", staticClass: "c-table__container" }, [
            _c(
              "thead",
              { ref: "header", staticClass: "c-table__header" },
              _vm._l(_vm.levels, function (i) {
                return _c(
                  "tr",
                  { key: i, staticClass: "c-table__header-row" },
                  [
                    _vm._l(_vm.getTableColumns(i), function (column) {
                      return _c(
                        "th",
                        {
                          key: column.id,
                          staticClass: "c-table__column",
                          class: {
                            "c-table__column_with_filter": column.type,
                            "c-table__column_hidden": _vm.isDisabled(column.id),
                            "c-table__column_sorted": _vm.isSorted(column),
                          },
                          style: { width: column.width ? column.width : "" },
                          attrs: {
                            id: `c-table-column-${column.id}`,
                            colspan: _vm.getColspan(column),
                            rowspan: _vm.getRowspan(column),
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "c-table__column-wrapper" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "c-table__column-label",
                                  class: {
                                    "c-table__column-label-children":
                                      !_vm.isCategory(column) &&
                                      _vm.sortedColumn,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setSortedColumn(
                                        column,
                                        _vm.sortedColumn
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(column.label) + " ")]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    _vm.data.actions && i === 1 && _vm.data.records.length > 0
                      ? _c(
                          "th",
                          {
                            staticClass:
                              "c-table__column c-table__column_actions",
                            attrs: { rowspan: _vm.levels },
                          },
                          [_c("div", { staticClass: "c-table__column-empty" })]
                        )
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
            _c(
              "tbody",
              { staticClass: "c-table__records" },
              _vm._l(_vm.data.records, function (record, recordIndex) {
                return _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: record.isShowRow,
                        expression: "record.isShowRow",
                      },
                    ],
                    key: recordIndex,
                    staticClass: "c-table__record",
                  },
                  [
                    _vm._l(_vm.getTableColumns(_vm.levels), function (column) {
                      return _c(
                        "td",
                        {
                          key: column.id,
                          staticClass: "c-table__cell",
                          class: {
                            "c-table__cell_string": column.type === "string",
                            "c-table__cell_reference":
                              column.type === "reference",
                            "c-table__cell_number": column.type === "number",
                            "c-table__cell_date": column.type === "date",
                            "c-table__cell_hidden": _vm.isDisabled(column.id),
                            ["c-table__cell_" + column.id]: column.id,
                          },
                        },
                        [
                          column.id === "name"
                            ? _c("c-table-cell-name", {
                                attrs: { record: record },
                              })
                            : _c(
                                "div",
                                { staticClass: "c-table__cell-value" },
                                [_vm._v(_vm._s(record[column.id].value))]
                              ),
                        ],
                        1
                      )
                    }),
                    _vm.data.actions && _vm.data.records.length > 0
                      ? _c(
                          "td",
                          {
                            staticClass: "c-table__cell c-table__cell_actions",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "c-table__cell-actions" },
                              [
                                _vm.data.type === "employees"
                                  ? _c("c-table-actions", {
                                      attrs: {
                                        type: _vm.data.type,
                                        record: record,
                                        "record-index": recordIndex,
                                        "record-count": _vm.data.records.length,
                                      },
                                    })
                                  : _vm._e(),
                                _vm.data.type === "reference-clients"
                                  ? _c("c-table-reference-clients-actions", {
                                      attrs: { record: record },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
          ]),
        ]
      ),
      _vm.data.records.length === 0
        ? _c("div", { staticClass: "c-table__empty__records" }, [
            _vm._v(_vm._s(_vm.emptyRecordsLabel)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }